import React from 'react';
import SocialMediaLinksStyles from './SocialMediaLinks.module.css';


export default function SocialMediaLinks({children}){
    return <div id={SocialMediaLinksStyles['SocialMedia-Links']}>
                {children}
            </div>
}